
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/security-compliance",
      function () {
        return require("private-next-pages/docs/security-compliance.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/security-compliance"])
      });
    }
  